export const money = (n) => `€ ${Number(n || 0).toLocaleString("it-IT", { maximumFractionDigits: 2 })}`;

export const CATEGORIE = [
  ["profili", "Profili"], ["vetro", "Vetro"], ["ferramenta", "Ferramenta"], ["accessori", "Accessori"],
  ["trasporti", "Trasporti"], ["carburante", "Carburante"], ["sopralluogo", "Sopralluogo"],
  ["posa", "Posa"], ["manodopera", "Manodopera"], ["altri", "Altri"],
];

export const TIPI_PRODOTTO = [
  ["finestre", "Finestre"], ["portefinestre", "Portefinestre"], ["scorrevoli", "Scorrevoli"],
  ["porte", "Porte"], ["facciate", "Facciate"], ["pergole", "Pergole"], ["altri", "Altri"],
];
